// Simulate a partial productData field with the GraphQL nullable states
type WebshopData =
  | {
      // This field comes from GraphQL JSON; only explicit BC booleans have a known status.
      enableInWebshop?: unknown;
    }
  | null
  | undefined;

/** Get the BC webshop status */
export const getWebshopStatus = (productData: WebshopData): boolean | null => {
  const enabled = productData?.enableInWebshop;
  return typeof enabled === "boolean" ? enabled : null;
};

/** Derives the BC webshop status of a group from its variants */
export const getGroupWebshopStatus = (
  variants: readonly { productData?: WebshopData }[],
): boolean | null => {
  const statuses = variants.map((variant) =>
    getWebshopStatus(variant.productData),
  );
  if (statuses.includes(true)) return true;
  // An empty group is hidden; missing BC data must not be mistaken for an explicit false.
  return statuses.includes(null) ? null : false;
};
